export default {
  autoplay() {
    this.el.play()
    // Tell the server that we auto-played, so it can remove the `autoplay` query param from the URL.
    // This prevents unintentional auto-playing from e.g. liveview reconnects.
    this.pushEventTo(this.el, 'autoplay_fulfilled', {})
  },
  maybeAutoplay() {
    const { autoplay, timestamp } = this.el.dataset
    const startTime = (timestamp || 0) * 1
    if (this.el.readyState > 0 && startTime < this.el.duration) {
      this.el.currentTime = startTime
      if (autoplay) {
        this.autoplay()
      }
    }
  },
  mounted() {
    this.maybeAutoplay()
    this.el.addEventListener('loadedmetadata', () => {
      this.maybeAutoplay()
    })
  },
  updated() {
    this.maybeAutoplay()
  },
  // destroyed() {
  //   this.el.stop()
  // },
}
